import * as React from 'react';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import connectWithRouter from '../../redux/connectWithRouter';
import {StoreState} from '../../../../App/initialStore';
import FormRadio, {RadioBoolean} from 'cl-form/FormRadio/FormRadio';
import EbayListingsActions from '../../../ActionsManager/EbayListingsActions/EbayListingsActions';
import {getNonChildrenCount, getNonChildrenValidDataCount} from 'cl-table/redux/selectors';
import Typography from '@material-ui/core/Typography';
import {Tables} from 'cl-api';

export interface PublishConfirmationDialogFormData {
  createDraftIfNotReady: RadioBoolean;
}

export type PublishToEbayConfirmationDialogProps = SpecificFormDialogProps<
  PublishConfirmationDialogFormData,
  {count: number; sellerId: string; site: string; readyCount: number}
>;

class PublishToEbayConfirmationDialog extends React.PureComponent<PublishToEbayConfirmationDialogProps> {
  render() {
    const {readyCount, count, sellerId, site, ...props} = this.props;
    const allReady = readyCount === count;
    return (
      <FormDialog<PublishConfirmationDialogFormData>
        formName={EBAY_LISTINGS_ACTIONS_TYPES.PUBLISH_PRODUCTS_TO_EBAY}
        initialValues={{createDraftIfNotReady: RadioBoolean.true}}
        title={`Publish ${count} products to ${sellerId} site ${site}`}
        text={
          <React.Fragment>
            <Typography>
              {allReady ? 'All' : readyCount} products are <strong>ready</strong> to be published to this channel
            </Typography>
            {!allReady ? (
              <Typography>
                {count - readyCount} products are <strong>not ready</strong> to be published
              </Typography>
            ) : (
              undefined
            )}
          </React.Fragment>
        }
        fields={
          allReady
            ? []
            : [
                {
                  component: FormRadio,
                  name: 'createDraftIfNotReady',
                  props: {
                    options: [
                      {
                        value: RadioBoolean.true,
                        label: 'Create draft listings from products not ready to be published',
                      },
                      {
                        value: RadioBoolean.false,
                        label: (
                          <React.Fragment>
                            <strong>Don't</strong> create draft listings from products not ready to be published
                          </React.Fragment>
                        ),
                      },
                    ],
                  },
                },
              ]
        }
        actions={
          <EbayListingsActions
            noObjects
            types={[EBAY_LISTINGS_ACTIONS_TYPES.PUBLISH_PRODUCTS_TO_EBAY]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          />
        }
        {...props}
      />
    );
  }
}

export default connectWithRouter((state: StoreState) => {
  const tableState = state.table[Tables.PublishToEbayTable as any];
  if (tableState) {
    return {
      count: getNonChildrenCount(tableState),
      readyCount: getNonChildrenValidDataCount(tableState),
      sellerId: tableState.initParams.sellerId,
      site: tableState.initParams.site,
    };
  }
})(PublishToEbayConfirmationDialog);
